/**
 * 班级api
 * 班级api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import IdNameVo from './IdNameVo';




  /**
   * The UserVo model module.
   * @module user/model/UserVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>UserVo</code>.
   * @alias module:user/model/UserVo
   * @class
   */
  var exports = function() {
    var _this = this;














  };

  /**
   * Constructs a <code>UserVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:user/model/UserVo} obj Optional instance to populate.
   * @return {module:user/model/UserVo} The populated <code>UserVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'accountId')) {
        obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'phoneNum')) {
        obj['phoneNum'] = ApiClient.convertToType(data['phoneNum'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'avatarUrl')) {
        obj['avatarUrl'] = ApiClient.convertToType(data['avatarUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gender')) {
        obj['gender'] = ApiClient.convertToType(data['gender'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'position')) {
        obj['position'] = ApiClient.convertToType(data['position'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'dingOrgList')) {
        obj['dingOrgList'] = ApiClient.convertToType(data['dingOrgList'], [IdNameVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'dept')) {
        obj['dept'] = IdNameVo.constructFromObject(data['dept']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'major')) {
        obj['major'] = IdNameVo.constructFromObject(data['major']);
      }
    }
    return obj;
  }

  /**
   * 用户id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 账号id
   * @member {Integer} accountId
   */
  exports.prototype['accountId'] = undefined;
  /**
   * 0学生1老师
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 手机号
   * @member {String} phoneNum
   */
  exports.prototype['phoneNum'] = undefined;
  /**
   * 头像
   * @member {String} avatarUrl
   */
  exports.prototype['avatarUrl'] = undefined;
  /**
   * 性别 0：未知、1：男、2：女
   * @member {Integer} gender
   */
  exports.prototype['gender'] = undefined;
  /**
   * 学号/工号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 0：可用；1：禁用
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;
  /**
   * 职位
   * @member {String} position
   */
  exports.prototype['position'] = undefined;
  /**
   * @member {Array.<module:user/model/IdNameVo>} dingOrgList
   */
  exports.prototype['dingOrgList'] = undefined;
  /**
   * 院系
   * @member {module:user/model/IdNameVo} dept
   */
  exports.prototype['dept'] = undefined;
  /**
   * 专业
   * @member {module:user/model/IdNameVo} major
   */
  exports.prototype['major'] = undefined;



  export default exports;
;


